import { Citation } from '#/api'
import { useMemo } from 'react'
import styles from './PdfPreview.module.css'

type PdfPreviewPanelProps = { citation: Citation }

export const PdfPreviewPanel = ({ citation }: PdfPreviewPanelProps) => {
  const url = useMemo(() => {
    const hash = Date.now()
    const page = citation.page_from ?? 1
    return `${citation.url}&cacheBuster=${hash}#page=${page}&view=FitW&view=FitH`
  }, [citation])

  return <iframe src={url} className={styles.pdfPreviewContent} />
}
